import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Text } from '/src/components';

export type UsagesDataTableHeaderProps = {
  label: string;
  width?: string | number;
  minWidth?: string | number;
  style?: React.CSSProperties;
  required?: boolean;
};

export const UsagesDataTableHeader: React.FC<UsagesDataTableHeaderProps> = observer((props) => {
  const { label, width, minWidth, style, required } = props;

  return (
    <Box
      width={typeof width === 'number' ? `${width}px` : width}
      minWidth={minWidth ? (typeof minWidth === 'number' ? `${minWidth}px` : minWidth) : undefined}
      align="center"
      justify="center"
      border={{ side: 'all', size: '0.4px', color: 'light-2' }}
      pad="small"
      flex={false}
      style={{
        height: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      <Text
        size="small"
        weight={300}
        toUpperCase
        textAlign="center"
        style={{
          maxHeight: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {label}
        {required === true && ' *'}
      </Text>
    </Box>
  );
});
